export default "__VITE_ASSET__BH$q5HjG__"